
import { Vue, Component } from 'vue-property-decorator';
import ImgUpload from './imgUpload.vue';

@Component({
  components: {
    ImgUpload,
  },
})
export default class PrivacyPhone extends Vue {
  visible = false;

  form = {
    name: '',
    idCard: '',
    userType: '',
  };
  privacyFun() {
    // console.log('实名验证');
  }
  init(item: any) {
    this.visible = true;
    this.form.name = item.name;
    this.form.idCard = item.idCard;
  }
  cancel() {
    this.visible = false;
  }
}
